import { render, staticRenderFns } from "./DropZoneComponentNew2.vue?vue&type=template&id=23eb0d98&scoped=true"
import script from "./DropZoneComponentNew2.vue?vue&type=script&lang=js"
export * from "./DropZoneComponentNew2.vue?vue&type=script&lang=js"
import style0 from "./DropZoneComponentNew2.vue?vue&type=style&index=0&id=23eb0d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb0d98",
  null
  
)

export default component.exports